import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./i18n";
import { AuthProvider } from "../src/Context/AuthContext";
import { CountProvider } from "../src/Context/CountContext";
import { FilterProvider } from "../src/Context/FilterContext";
import { HelmetProvider } from "react-helmet-async";



import { configureStore } from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={configureStore({})}>
		<React.Fragment>
			<BrowserRouter>
				<AuthProvider>
					<HelmetProvider>
						<CountProvider>
							<FilterProvider>
								<App />
							</FilterProvider>
						</CountProvider>
					</HelmetProvider>
				</AuthProvider>
			</BrowserRouter>
		</React.Fragment>
	</Provider>
);
reportWebVitals();

